module.exports = __webpack_public_path__ + "media/images/story/typo/greetingsCute-0bd2db0b6633d5ce17f27c11707b116c.svg";